import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";

export default (inviteId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<{}, null>(
    `invite_${inviteId}`,
    async () =>
      Put(
        `/api/invite/purchaser/accept/${inviteId}`,
        await getAccessTokenSilently()
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`user`]);
      },
    }
  );
};
